var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _path0, _g3, _path1, _path10, _path11, _path12, _path13, _g4, _path14, _path15, _path16, _path17, _path18, _g5, _path19, _path20, _path21, _path22, _g6, _path23, _path24, _path25, _path26, _path27, _g7, _path28, _path29, _path30, _path31, _path32, _g8, _path33, _path34, _path35, _path36, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDdbg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 10232,
    viewBox: "0 0 1920 10232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.975 979.553C408.559 1021.09 191.533 759.116 181.865 522.183C172.44 291.209 322.502 389.076 674.556 221.763C611.921 302.475 1333.24 143.678 1282.42 234.344C1231.6 325.01 910.858 596.603 838.177 680.271C765.496 763.939 741.392 938.016 574.975 979.553Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2180.46 607.421C2446 537.422 2302.37 477.267 2036.83 158.993C1893.21 99.9315 1624.33 69.3071 1472.35 158.993C1320.37 248.678 1564.2 402.894 1564.2 527.579C1564.2 652.264 1914.92 677.419 2180.46 607.421Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.04 1264.59C1735.06 1178.79 1558.72 1105.05 1232.7 714.908C1056.37 642.51 726.246 604.971 539.657 714.908C353.067 824.845 652.431 1013.88 652.431 1166.72C652.431 1319.56 1083.02 1350.4 1409.04 1264.59Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.77 678.089C1393.02 472.947 1472.49 608.482 1822.36 640.185C1791.25 662.975 1773.17 706.737 1949.74 699.47C2170.45 690.387 2117.33 809.79 2164.08 934.563C2210.82 1059.34 2220.88 1159.85 2043.89 1239.82C1866.91 1319.79 1854.27 1251.98 1679 1162.17C1503.73 1072.35 1493.73 1123.13 1325.4 992.419C1157.07 861.709 1222.52 883.232 1307.77 678.089Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.656 307.466C785.906 102.323 865.376 237.858 1215.24 269.562C1184.14 292.351 1166.06 336.113 1342.63 328.847C1563.34 319.763 1510.22 439.166 1556.96 563.939C1603.71 688.713 1613.77 789.225 1436.78 869.197C1259.79 949.169 1247.16 881.36 1071.89 791.544C896.619 701.727 886.62 752.505 718.29 621.795C549.961 491.085 615.406 512.608 700.656 307.466Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter1_f_1174_527)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574.975 979.553C408.559 1021.09 191.533 759.116 181.865 522.183C172.44 291.209 322.502 389.076 674.556 221.763C611.921 302.475 1333.24 143.678 1282.42 234.344C1231.6 325.01 910.858 596.603 838.177 680.271C765.496 763.939 741.392 938.016 574.975 979.553Z",
    fill: "#526860"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2180.46 607.421C2446 537.422 2302.37 477.267 2036.83 158.993C1893.21 99.9315 1624.33 69.3071 1472.35 158.993C1320.37 248.678 1564.2 402.894 1564.2 527.579C1564.2 652.264 1914.92 677.419 2180.46 607.421Z",
    fill: "#6CD8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.04 1264.59C1735.06 1178.79 1558.72 1105.05 1232.7 714.909C1056.37 642.511 726.246 604.972 539.657 714.909C353.067 824.846 652.431 1013.88 652.431 1166.72C652.431 1319.56 1083.02 1350.4 1409.04 1264.59Z",
    fill: "#101C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1307.77 678.089C1393.02 472.947 1472.49 608.482 1822.36 640.185C1791.25 662.975 1773.17 706.737 1949.74 699.47C2170.45 690.387 2117.33 809.79 2164.08 934.563C2210.82 1059.34 2220.88 1159.85 2043.89 1239.82C1866.91 1319.79 1854.27 1251.98 1679 1162.17C1503.73 1072.35 1493.73 1123.13 1325.4 992.419C1157.07 861.709 1222.52 883.232 1307.77 678.089Z",
    fill: "#234136"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M700.656 307.466C785.906 102.323 865.376 237.858 1215.24 269.562C1184.14 292.351 1166.06 336.113 1342.63 328.847C1563.34 319.763 1510.22 439.166 1556.96 563.939C1603.71 688.713 1613.77 789.225 1436.78 869.197C1259.79 949.169 1247.16 881.36 1071.89 791.544C896.619 701.727 886.62 752.505 718.29 621.795C549.961 491.085 615.406 512.608 700.656 307.466Z",
    fill: "#777777"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M689.931 2107.91C513.992 2149.09 284.545 1889.35 274.324 1654.44C264.36 1425.43 423.009 1522.47 795.21 1356.58C728.991 1436.61 1491.59 1279.16 1437.86 1369.05C1384.13 1458.95 1045.04 1728.23 968.195 1811.18C891.355 1894.13 865.871 2066.73 689.931 2107.91Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.08 2453.86C1375.81 2384.46 1223.97 2324.81 943.231 2009.25C791.386 1950.7 507.117 1920.33 346.444 2009.25C185.771 2098.17 443.554 2251.08 443.554 2374.7C443.554 2498.32 814.339 2523.26 1095.08 2453.86Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2603.85 2189.63C2948.53 2104.56 2762.1 2031.45 2417.42 1644.63C2230.99 1572.85 1881.98 1535.63 1684.71 1644.63C1487.44 1753.63 1803.94 1941.06 1803.94 2092.6C1803.94 2244.13 2259.17 2274.71 2603.85 2189.63Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.81 2012.52C1846.94 1809.13 1930.95 1943.5 2300.85 1974.94C2267.96 1997.53 2248.85 2040.92 2435.52 2033.72C2668.86 2024.71 2612.7 2143.1 2662.12 2266.81C2711.54 2390.52 2722.17 2490.17 2535.06 2569.46C2347.95 2648.75 2334.59 2581.52 2149.29 2492.47C1963.99 2403.42 1953.41 2453.76 1775.45 2324.17C1597.49 2194.57 1666.68 2215.91 1756.81 2012.52Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.548 1558.34C926.676 1354.94 1010.69 1489.32 1380.58 1520.76C1347.7 1543.35 1328.59 1586.74 1515.26 1579.54C1748.6 1570.53 1692.44 1688.92 1741.86 1812.63C1791.28 1936.34 1801.91 2035.99 1614.8 2115.28C1427.68 2194.57 1414.32 2127.34 1229.02 2038.29C1043.72 1949.24 1033.15 1999.58 855.191 1869.99C677.229 1740.39 746.419 1761.73 836.548 1558.34Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter3_f_1174_527)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M703.674 2224.7C527.735 2265.88 298.288 2006.14 288.067 1771.23C278.103 1542.22 436.752 1639.25 808.954 1473.37C742.734 1553.39 1505.34 1395.95 1451.6 1485.84C1397.87 1575.73 1058.78 1845.01 981.939 1927.97C905.098 2010.92 879.614 2183.51 703.674 2224.7Z",
    fill: "#526860"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1545.06 2510.94C1825.79 2441.54 1673.95 2381.9 1393.21 2066.34C1241.37 2007.78 957.098 1977.42 796.425 2066.34C635.751 2155.26 893.535 2308.16 893.535 2431.78C893.535 2555.4 1264.32 2580.34 1545.06 2510.94Z",
    fill: "#6CD8FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.8 1906.7C2268.48 1821.63 2082.05 1748.52 1737.38 1361.7C1550.95 1289.92 1201.93 1252.7 1004.67 1361.7C807.398 1470.7 1123.89 1658.13 1123.89 1809.66C1123.89 1961.2 1579.13 1991.77 1923.8 1906.7Z",
    fill: "#101C41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M389.951 1605.49C480.079 1402.1 564.097 1536.48 933.987 1567.91C901.099 1590.51 881.99 1633.9 1068.66 1626.69C1302 1617.69 1245.84 1736.07 1295.26 1859.78C1344.69 1983.49 1355.32 2083.15 1168.2 2162.44C981.088 2241.73 967.728 2174.5 782.428 2085.44C597.128 1996.39 586.557 2046.74 408.594 1917.14C230.631 1787.55 299.822 1808.89 389.951 1605.49Z",
    fill: "#234136"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2057.92 1488.85C2148.05 1285.45 2232.07 1419.83 2601.96 1451.27C2569.07 1473.86 2549.96 1517.25 2736.64 1510.05C2969.98 1501.04 2913.81 1619.42 2963.24 1743.13C3012.66 1866.84 3023.29 1966.5 2836.17 2045.79C2649.06 2125.08 2635.7 2057.85 2450.4 1968.8C2265.1 1879.75 2254.53 1930.09 2076.57 1800.5C1898.6 1670.9 1967.79 1692.24 2057.92 1488.85Z",
    fill: "#777777"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2190.95 3508.09C2366.89 3466.91 2596.34 3726.65 2606.56 3961.56C2616.53 4190.57 2457.88 4093.53 2085.68 4259.42C2151.89 4179.4 1389.29 4336.84 1443.02 4246.95C1496.76 4157.05 1835.85 3887.78 1912.69 3804.82C1989.53 3721.87 2015.01 3549.27 2190.95 3508.09Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.81 3162.14C1505.07 3231.54 1656.92 3291.19 1937.66 3606.75C2089.5 3665.3 2373.77 3695.67 2534.44 3606.75C2695.11 3517.83 2437.33 3364.93 2437.33 3241.3C2437.33 3117.68 2066.55 3092.74 1785.81 3162.14Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.035 3426.37C-67.6415 3511.44 118.788 3584.55 463.465 3971.37C649.894 4043.15 998.906 4080.37 1196.17 3971.37C1393.44 3862.37 1076.95 3674.94 1076.95 3523.4C1076.95 3371.87 621.712 3341.3 277.035 3426.37Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.08 3603.48C1033.95 3806.88 949.931 3672.5 580.04 3641.06C612.929 3618.47 632.037 3575.08 445.365 3582.28C212.024 3591.29 268.187 3472.9 218.765 3349.19C169.342 3225.49 158.711 3125.83 345.826 3046.54C532.94 2967.25 546.3 3034.48 731.6 3123.53C916.9 3212.58 927.471 3162.24 1105.43 3291.83C1283.4 3421.43 1214.21 3400.09 1124.08 3603.48Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2044.34 4057.66C1954.21 4261.06 1870.19 4126.68 1500.3 4095.24C1533.19 4072.65 1552.3 4029.26 1365.63 4036.46C1132.28 4045.47 1188.45 3927.09 1139.03 3803.38C1089.6 3679.67 1078.97 3580.01 1266.09 3500.72C1453.2 3421.43 1466.56 3488.66 1651.86 3577.71C1837.16 3666.76 1847.73 3616.42 2025.69 3746.01C2203.66 3875.61 2134.47 3854.27 2044.34 4057.66Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter5_f_1174_527)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2478.33 3180.33C2654.27 3139.14 2883.71 3398.88 2893.93 3633.8C2903.9 3862.8 2745.25 3765.77 2373.05 3931.65C2439.27 3851.63 1676.67 4009.07 1730.4 3919.18C1784.13 3829.29 2123.22 3560.01 2200.06 3477.06C2276.9 3394.1 2302.39 3221.51 2478.33 3180.33Z",
    fill: "#526860"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.95 2894.08C1356.21 2963.48 1508.05 3023.12 1788.79 3338.69C1940.64 3397.24 2224.9 3427.61 2385.58 3338.69C2546.25 3249.76 2288.47 3096.86 2288.47 2973.24C2288.47 2849.62 1917.68 2824.68 1636.95 2894.08Z",
    fill: "#6CD8FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1258.2 3498.32C913.52 3583.4 1099.95 3656.5 1444.63 4043.32C1631.05 4115.1 1980.07 4152.32 2177.34 4043.32C2374.6 3934.32 2058.11 3746.89 2058.11 3595.36C2058.11 3443.82 1602.87 3413.25 1258.2 3498.32Z",
    fill: "#101C41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2792.05 3799.53C2701.92 4002.92 2617.9 3868.54 2248.01 3837.11C2280.9 3814.51 2300.01 3771.12 2113.34 3778.33C1880 3787.34 1936.16 3668.95 1886.74 3545.24C1837.32 3421.53 1826.69 3321.88 2013.8 3242.59C2200.91 3163.3 2214.27 3230.53 2399.57 3319.58C2584.87 3408.63 2595.44 3358.28 2773.41 3487.88C2951.37 3617.47 2882.18 3596.13 2792.05 3799.53Z",
    fill: "#234136"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.08 3916.17C1033.95 4119.57 949.932 3985.19 580.041 3953.76C612.93 3931.16 632.038 3887.77 445.366 3894.98C212.025 3903.98 268.188 3785.6 218.766 3661.89C169.343 3538.18 158.712 3438.52 345.827 3359.23C532.941 3279.94 546.301 3347.17 731.601 3436.22C916.901 3525.27 927.472 3474.93 1105.43 3604.53C1283.4 3734.12 1214.21 3712.78 1124.08 3916.17Z",
    fill: "#777777"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M855.975 5416.55C689.559 5458.09 472.533 5196.12 462.865 4959.18C453.44 4728.21 603.502 4826.08 955.556 4658.76C892.921 4739.48 1614.24 4580.68 1563.42 4671.34C1512.6 4762.01 1191.86 5033.6 1119.18 5117.27C1046.5 5200.94 1022.39 5375.02 855.975 5416.55Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2461.46 5044.42C2727 4974.42 2583.37 4914.27 2317.83 4595.99C2174.21 4536.93 1905.33 4506.31 1753.35 4595.99C1601.37 4685.68 1845.2 4839.89 1845.2 4964.58C1845.2 5089.26 2195.92 5114.42 2461.46 5044.42Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1690.04 5701.59C2016.06 5615.79 1839.72 5542.05 1513.7 5151.91C1337.37 5079.51 1007.25 5041.97 820.657 5151.91C634.067 5261.85 933.431 5450.88 933.431 5603.72C933.431 5756.56 1364.02 5787.4 1690.04 5701.59Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.77 5115.09C1674.02 4909.95 1753.49 5045.48 2103.36 5077.19C2072.25 5099.97 2054.17 5143.74 2230.74 5136.47C2451.45 5127.39 2398.33 5246.79 2445.08 5371.56C2491.82 5496.34 2501.88 5596.85 2324.89 5676.82C2147.91 5756.79 2135.27 5688.98 1960 5599.17C1784.73 5509.35 1774.73 5560.13 1606.4 5429.42C1438.07 5298.71 1503.52 5320.23 1588.77 5115.09Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.656 4744.47C1066.91 4539.32 1146.38 4674.86 1496.24 4706.56C1465.14 4729.35 1447.06 4773.11 1623.63 4765.85C1844.34 4756.76 1791.22 4876.17 1837.96 5000.94C1884.71 5125.71 1894.77 5226.23 1717.78 5306.2C1540.79 5386.17 1528.16 5318.36 1352.89 5228.54C1177.62 5138.73 1167.62 5189.51 999.29 5058.8C830.961 4928.09 896.406 4949.61 981.656 4744.47Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter7_f_1174_527)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M855.975 5416.55C689.559 5458.09 472.533 5196.12 462.865 4959.18C453.44 4728.21 603.502 4826.08 955.556 4658.76C892.921 4739.48 1614.24 4580.68 1563.42 4671.34C1512.6 4762.01 1191.86 5033.6 1119.18 5117.27C1046.5 5200.94 1022.39 5375.02 855.975 5416.55Z",
    fill: "#526860"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2461.46 5044.42C2727 4974.42 2583.37 4914.27 2317.83 4595.99C2174.21 4536.93 1905.33 4506.31 1753.35 4595.99C1601.37 4685.68 1845.2 4839.89 1845.2 4964.58C1845.2 5089.26 2195.92 5114.42 2461.46 5044.42Z",
    fill: "#6CD8FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1690.04 5701.59C2016.06 5615.79 1839.72 5542.05 1513.7 5151.91C1337.37 5079.51 1007.25 5041.97 820.657 5151.91C634.067 5261.85 933.431 5450.88 933.431 5603.72C933.431 5756.56 1364.02 5787.4 1690.04 5701.59Z",
    fill: "#101C41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1588.77 5115.09C1674.02 4909.95 1753.49 5045.48 2103.36 5077.19C2072.25 5099.97 2054.17 5143.74 2230.74 5136.47C2451.45 5127.39 2398.33 5246.79 2445.08 5371.56C2491.82 5496.34 2501.88 5596.85 2324.89 5676.82C2147.91 5756.79 2135.27 5688.98 1960 5599.17C1784.73 5509.35 1774.73 5560.13 1606.4 5429.42C1438.07 5298.71 1503.52 5320.23 1588.77 5115.09Z",
    fill: "#234136"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M981.656 4744.47C1066.91 4539.32 1146.38 4674.86 1496.24 4706.56C1465.14 4729.35 1447.06 4773.11 1623.63 4765.85C1844.34 4756.76 1791.22 4876.17 1837.96 5000.94C1884.71 5125.71 1894.77 5226.23 1717.78 5306.2C1540.79 5386.17 1528.16 5318.36 1352.89 5228.54C1177.62 5138.73 1167.62 5189.51 999.29 5058.8C830.961 4928.09 896.406 4949.61 981.656 4744.47Z",
    fill: "#777777"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970.931 6544.91C794.992 6586.09 565.545 6326.35 555.324 6091.44C545.36 5862.43 704.009 5959.47 1076.21 5793.58C1009.99 5873.61 1772.59 5716.16 1718.86 5806.05C1665.13 5895.95 1326.04 6165.23 1249.2 6248.18C1172.35 6331.13 1146.87 6503.73 970.931 6544.91Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.08 6890.86C1656.81 6821.46 1504.97 6761.82 1224.23 6446.25C1072.39 6387.7 788.117 6357.33 627.444 6446.25C466.771 6535.18 724.554 6688.08 724.554 6811.7C724.554 6935.32 1095.34 6960.26 1376.08 6890.86Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2884.85 6626.63C3229.53 6541.56 3043.1 6468.45 2698.42 6081.63C2511.99 6009.85 2162.98 5972.63 1965.71 6081.63C1768.44 6190.63 2084.94 6378.06 2084.94 6529.6C2084.94 6681.13 2540.17 6711.71 2884.85 6626.63Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037.81 6449.52C2127.94 6246.13 2211.95 6380.5 2581.85 6411.94C2548.96 6434.53 2529.85 6477.92 2716.52 6470.72C2949.86 6461.71 2893.7 6580.1 2943.12 6703.81C2992.54 6827.52 3003.17 6927.17 2816.06 7006.46C2628.95 7085.75 2615.59 7018.52 2430.29 6929.47C2244.99 6840.42 2234.41 6890.76 2056.45 6761.17C1878.49 6631.57 1947.68 6652.91 2037.81 6449.52Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.55 5995.34C1207.68 5791.94 1291.69 5926.32 1661.58 5957.76C1628.7 5980.35 1609.59 6023.74 1796.26 6016.54C2029.6 6007.53 1973.44 6125.92 2022.86 6249.63C2072.28 6373.34 2082.91 6472.99 1895.8 6552.28C1708.68 6631.57 1695.32 6564.34 1510.02 6475.29C1324.72 6386.24 1314.15 6436.58 1136.19 6306.99C958.229 6177.39 1027.42 6198.73 1117.55 5995.34Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter9_f_1174_527)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M984.674 6661.7C808.735 6702.88 579.288 6443.14 569.067 6208.23C559.103 5979.22 717.752 6076.25 1089.95 5910.37C1023.73 5990.39 1786.34 5832.95 1732.6 5922.84C1678.87 6012.73 1339.78 6282.01 1262.94 6364.97C1186.1 6447.92 1160.61 6620.51 984.674 6661.7Z",
    fill: "#526860"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1826.06 6947.94C2106.79 6878.54 1954.95 6818.9 1674.21 6503.34C1522.37 6444.78 1238.1 6414.42 1077.42 6503.34C916.751 6592.26 1174.53 6745.16 1174.53 6868.78C1174.53 6992.4 1545.32 7017.34 1826.06 6947.94Z",
    fill: "#6CD8FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2204.8 6343.7C2549.48 6258.63 2363.05 6185.52 2018.38 5798.7C1831.95 5726.92 1482.93 5689.7 1285.67 5798.7C1088.4 5907.7 1404.89 6095.13 1404.89 6246.66C1404.89 6398.2 1860.13 6428.77 2204.8 6343.7Z",
    fill: "#101C41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M670.951 6042.49C761.079 5839.1 845.097 5973.48 1214.99 6004.91C1182.1 6027.51 1162.99 6070.9 1349.66 6063.69C1583 6054.69 1526.84 6173.07 1576.26 6296.78C1625.69 6420.49 1636.32 6520.15 1449.2 6599.44C1262.09 6678.73 1248.73 6611.5 1063.43 6522.45C878.128 6433.39 867.557 6483.74 689.594 6354.14C511.631 6224.55 580.822 6245.89 670.951 6042.49Z",
    fill: "#234136"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2471.95 7945.09C2647.89 7903.91 2877.34 8163.65 2887.56 8398.56C2897.53 8627.57 2738.88 8530.53 2366.68 8696.42C2432.89 8616.4 1670.29 8773.84 1724.02 8683.95C1777.76 8594.05 2116.85 8324.78 2193.69 8241.82C2270.53 8158.87 2296.01 7986.27 2471.95 7945.09Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066.81 7599.14C1786.07 7668.54 1937.92 7728.19 2218.66 8043.75C2370.5 8102.3 2654.77 8132.67 2815.44 8043.75C2976.11 7954.83 2718.33 7801.93 2718.33 7678.3C2718.33 7554.68 2347.55 7529.74 2066.81 7599.14Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.035 7863.37C213.359 7948.44 399.788 8021.55 744.465 8408.37C930.894 8480.15 1279.91 8517.37 1477.17 8408.37C1674.44 8299.37 1357.95 8111.94 1357.95 7960.4C1357.95 7808.87 902.712 7778.3 558.035 7863.37Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.08 8040.48C1314.95 8243.88 1230.93 8109.5 861.04 8078.06C893.929 8055.47 913.037 8012.08 726.365 8019.28C493.024 8028.29 549.187 7909.9 499.765 7786.19C450.342 7662.49 439.711 7562.83 626.826 7483.54C813.94 7404.25 827.3 7471.48 1012.6 7560.53C1197.9 7649.58 1208.47 7599.24 1386.43 7728.83C1564.4 7858.43 1495.21 7837.09 1405.08 8040.48Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325.34 8494.66C2235.21 8698.06 2151.19 8563.68 1781.3 8532.24C1814.19 8509.65 1833.3 8466.26 1646.63 8473.46C1413.28 8482.47 1469.45 8364.09 1420.03 8240.38C1370.6 8116.67 1359.97 8017.01 1547.09 7937.72C1734.2 7858.43 1747.56 7925.66 1932.86 8014.71C2118.16 8103.76 2128.73 8053.42 2306.69 8183.01C2484.66 8312.61 2415.47 8291.27 2325.34 8494.66Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter11_f_1174_527)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2759.33 7617.33C2935.27 7576.14 3164.71 7835.88 3174.93 8070.8C3184.9 8299.8 3026.25 8202.77 2654.05 8368.66C2720.27 8288.63 1957.67 8446.08 2011.4 8356.18C2065.13 8266.29 2404.22 7997.01 2481.06 7914.06C2557.9 7831.1 2583.39 7658.51 2759.33 7617.33Z",
    fill: "#526860"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1917.95 7331.08C1637.21 7400.48 1789.05 7460.12 2069.79 7775.69C2221.64 7834.24 2505.9 7864.61 2666.58 7775.69C2827.25 7686.76 2569.47 7533.86 2569.47 7410.24C2569.47 7286.62 2198.68 7261.68 1917.95 7331.08Z",
    fill: "#6CD8FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1539.2 7935.32C1194.52 8020.4 1380.95 8093.51 1725.63 8480.32C1912.05 8552.1 2261.07 8589.32 2458.34 8480.32C2655.6 8371.32 2339.11 8183.9 2339.11 8032.36C2339.11 7880.82 1883.87 7850.25 1539.2 7935.32Z",
    fill: "#101C41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3073.05 8236.53C2982.92 8439.92 2898.9 8305.54 2529.01 8274.11C2561.9 8251.51 2581.01 8208.13 2394.34 8215.33C2161 8224.34 2217.16 8105.95 2167.74 7982.24C2118.32 7858.53 2107.69 7758.88 2294.8 7679.59C2481.91 7600.3 2495.27 7667.53 2680.57 7756.58C2865.87 7845.63 2876.44 7795.28 3054.41 7924.88C3232.37 8054.47 3163.18 8033.13 3073.05 8236.53Z",
    fill: "#234136"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1405.08 8353.18C1314.95 8556.57 1230.93 8422.19 861.041 8390.76C893.93 8368.16 913.038 8324.77 726.366 8331.98C493.025 8340.98 549.188 8222.6 499.766 8098.89C450.343 7975.18 439.712 7875.52 626.827 7796.23C813.941 7716.94 827.301 7784.17 1012.6 7873.22C1197.9 7962.28 1208.47 7911.93 1386.43 8041.53C1564.4 8171.12 1495.21 8149.78 1405.08 8353.18Z",
    fill: "#777777"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M752.975 9779.55C586.559 9821.09 369.533 9559.12 359.865 9322.18C350.44 9091.21 500.502 9189.08 852.556 9021.76C789.921 9102.48 1511.24 8943.68 1460.42 9034.34C1409.6 9125.01 1088.86 9396.6 1016.18 9480.27C943.496 9563.94 919.392 9738.02 752.975 9779.55Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2358.46 9407.42C2624 9337.42 2480.37 9277.27 2214.83 8958.99C2071.21 8899.93 1802.33 8869.31 1650.35 8958.99C1498.37 9048.68 1742.2 9202.89 1742.2 9327.58C1742.2 9452.26 2092.92 9477.42 2358.46 9407.42Z",
    fill: "#6CD8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1587.04 10064.6C1913.06 9978.79 1736.72 9905.05 1410.7 9514.91C1234.37 9442.51 904.246 9404.97 717.657 9514.91C531.067 9624.84 830.431 9813.88 830.431 9966.72C830.431 10119.6 1261.02 10150.4 1587.04 10064.6Z",
    fill: "#101C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.77 9478.09C1571.02 9272.95 1650.49 9408.48 2000.36 9440.19C1969.25 9462.98 1951.17 9506.74 2127.74 9499.47C2348.45 9490.39 2295.33 9609.79 2342.08 9734.56C2388.82 9859.34 2398.88 9959.85 2221.89 10039.8C2044.91 10119.8 2032.27 10052 1857 9962.17C1681.73 9872.35 1671.73 9923.13 1503.4 9792.42C1335.07 9661.71 1400.52 9683.23 1485.77 9478.09Z",
    fill: "#234136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.656 9107.47C963.906 8902.32 1043.38 9037.86 1393.24 9069.56C1362.14 9092.35 1344.06 9136.11 1520.63 9128.85C1741.34 9119.76 1688.22 9239.17 1734.96 9363.94C1781.71 9488.71 1791.77 9589.23 1614.78 9669.2C1437.79 9749.17 1425.16 9681.36 1249.89 9591.54C1074.62 9501.73 1064.62 9552.51 896.29 9421.8C727.961 9291.09 793.406 9312.61 878.656 9107.47Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter13_f_1174_527)"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M752.975 9779.55C586.559 9821.09 369.533 9559.12 359.865 9322.18C350.44 9091.21 500.502 9189.08 852.556 9021.76C789.921 9102.48 1511.24 8943.68 1460.42 9034.34C1409.6 9125.01 1088.86 9396.6 1016.18 9480.27C943.496 9563.94 919.392 9738.02 752.975 9779.55Z",
    fill: "#526860"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2358.46 9407.42C2624 9337.42 2480.37 9277.27 2214.83 8958.99C2071.21 8899.93 1802.33 8869.31 1650.35 8958.99C1498.37 9048.68 1742.2 9202.89 1742.2 9327.58C1742.2 9452.26 2092.92 9477.42 2358.46 9407.42Z",
    fill: "#6CD8FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.04 10064.6C1913.06 9978.79 1736.72 9905.05 1410.7 9514.91C1234.37 9442.51 904.246 9404.97 717.657 9514.91C531.067 9624.85 830.431 9813.88 830.431 9966.72C830.431 10119.6 1261.02 10150.4 1587.04 10064.6Z",
    fill: "#101C41"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.77 9478.09C1571.02 9272.95 1650.49 9408.48 2000.36 9440.19C1969.25 9462.98 1951.17 9506.74 2127.74 9499.47C2348.45 9490.39 2295.33 9609.79 2342.08 9734.56C2388.82 9859.34 2398.88 9959.85 2221.89 10039.8C2044.91 10119.8 2032.27 10052 1857 9962.17C1681.73 9872.35 1671.73 9923.13 1503.4 9792.42C1335.07 9661.71 1400.52 9683.23 1485.77 9478.09Z",
    fill: "#234136"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M878.656 9107.47C963.906 8902.32 1043.38 9037.86 1393.24 9069.56C1362.14 9092.35 1344.06 9136.11 1520.63 9128.85C1741.34 9119.76 1688.22 9239.17 1734.96 9363.94C1781.71 9488.71 1791.77 9589.23 1614.78 9669.2C1437.79 9749.17 1425.16 9681.36 1249.89 9591.54C1074.62 9501.73 1064.62 9552.51 896.29 9421.8C727.961 9291.09 793.406 9312.61 878.656 9107.47Z",
    fill: "#777777"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_1174_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M867.931 10907.9C691.992 10949.1 462.545 10689.4 452.324 10454.4C442.36 10225.4 601.009 10322.5 973.21 10156.6C906.991 10236.6 1669.59 10079.2 1615.86 10169.1C1562.13 10258.9 1223.04 10528.2 1146.2 10611.2C1069.35 10694.1 1043.87 10866.7 867.931 10907.9Z",
    fill: "#526860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.55 10358.3C1104.68 10154.9 1188.69 10289.3 1558.58 10320.8C1525.7 10343.4 1506.59 10386.7 1693.26 10379.5C1926.6 10370.5 1870.44 10488.9 1919.86 10612.6C1969.28 10736.3 1979.91 10836 1792.8 10915.3C1605.68 10994.6 1592.32 10927.3 1407.02 10838.3C1221.72 10749.2 1211.15 10799.6 1033.19 10670C855.229 10540.4 924.419 10561.7 1014.55 10358.3Z",
    fill: "#777777"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter15_f_1174_527)"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M881.674 11024.7C705.735 11065.9 476.288 10806.1 466.067 10571.2C456.103 10342.2 614.752 10439.3 986.954 10273.4C920.734 10353.4 1683.34 10195.9 1629.6 10285.8C1575.87 10375.7 1236.78 10645 1159.94 10728C1083.1 10810.9 1057.61 10983.5 881.674 11024.7Z",
    fill: "#526860"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2101.8 10706.7C2446.48 10621.6 2260.05 10548.5 1915.38 10161.7C1728.95 10089.9 1379.93 10052.7 1182.67 10161.7C985.398 10270.7 1301.89 10458.1 1301.89 10609.7C1301.89 10761.2 1757.13 10791.8 2101.8 10706.7Z",
    fill: "#101C41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M567.951 10405.5C658.079 10202.1 742.097 10336.5 1111.99 10367.9C1079.1 10390.5 1059.99 10433.9 1246.66 10426.7C1480 10417.7 1423.84 10536.1 1473.26 10659.8C1522.69 10783.5 1533.32 10883.1 1346.2 10962.4C1159.09 11041.7 1145.73 10974.5 960.428 10885.4C775.128 10796.4 764.557 10846.7 586.594 10717.1C408.631 10587.5 477.822 10608.9 567.951 10405.5Z",
    fill: "#234136"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2235.92 10288.8C2326.05 10085.5 2410.07 10219.8 2779.96 10251.3C2747.07 10273.9 2727.96 10317.3 2914.64 10310C3147.98 10301 3091.81 10419.4 3141.24 10543.1C3190.66 10666.8 3201.29 10766.5 3014.17 10845.8C2827.06 10925.1 2813.7 10857.8 2628.4 10768.8C2443.1 10679.7 2432.53 10730.1 2254.57 10600.5C2076.6 10470.9 2145.79 10492.2 2235.92 10288.8Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1174_527",
    x: -398.552,
    y: -477.366,
    width: 3300.28,
    height: 2369.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1174_527",
    x: -398.552,
    y: -477.366,
    width: 3300.28,
    height: 2369.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1174_527",
    x: -306.117,
    y: 760.365,
    width: 3673.33,
    height: 2424.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1174_527",
    x: -292.374,
    y: 713.204,
    width: 3866.49,
    height: 2415.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1174_527",
    x: -486.331,
    y: 2431.33,
    width: 3673.33,
    height: 2424.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1174_527",
    x: -392.119,
    y: 2276,
    width: 3866.49,
    height: 2415.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1174_527",
    x: -117.552,
    y: 3959.63,
    width: 3300.28,
    height: 2369.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1174_527",
    x: -117.552,
    y: 3959.63,
    width: 3300.28,
    height: 2369.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1174_527",
    x: -25.1167,
    y: 5197.36,
    width: 3673.33,
    height: 2424.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1174_527",
    x: -11.3735,
    y: 5150.2,
    width: 3866.49,
    height: 2415.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1174_527",
    x: -205.331,
    y: 6868.33,
    width: 3673.33,
    height: 2424.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1174_527",
    x: -111.119,
    y: 6713,
    width: 3866.49,
    height: 2415.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1174_527",
    x: -220.552,
    y: 8322.63,
    width: 3300.28,
    height: 2369.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1174_527",
    x: -220.552,
    y: 8322.63,
    width: 3300.28,
    height: 2369.04,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_1174_527",
    x: -128.117,
    y: 9560.37,
    width: 3673.33,
    height: 2424.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_1174_527",
    x: -114.374,
    y: 9513.2,
    width: 3866.49,
    height: 2415.81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 290,
    result: "effect1_foregroundBlur_1174_527"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdbg);
export default __webpack_public_path__ + "static/media/ddbg.15ba354ea0038fe4dbb5d09c2fec4299.svg";
export { ForwardRef as ReactComponent };